import PropTypes from 'prop-types'

import Card from './index'
import Button from '../button'

import Typography from '../typography'
import Icon from '../icon'

import AccessTime from '../icon/access_time.svg'

const BlogxSmall2 = ({ title, ...attrs }) => {
  return (
    <div>
      <Card.Body>
        <div
          className={'flex  flex-row justify-between mb-4 items-center'}
        >
          <Typography
            className={' text-green-500 '}
          >
            ventas
          </Typography>
          <Typography
            size={'two'}
            className={' text-gray-400'}>
            16/09/2021
          </Typography>
        </div>

        <Typography
          className={'text-$black max-w-big mb-4'}
        >
          {title}
        </Typography>

        <div className={'flex items-center text-green-500'}>
          <Typography

          >
            Leer mass
          </Typography>
          <Button
            icon
            solid
            color={'pink'}
            href="https://www.google.com"
            target="_blank">

            <Icon
              size={20}
              svg={AccessTime}
            />
          </Button>
        </div>
      </Card.Body>
    </div>
  )
}

BlogxSmall2.propTypes = {
  title: PropTypes.string
}

export default BlogxSmall2
